import { render, staticRenderFns } from "./DashboardGenderOfLiveChickens.vue?vue&type=template&id=2b654c95&scoped=true"
import script from "./DashboardGenderOfLiveChickens.vue?vue&type=script&lang=js"
export * from "./DashboardGenderOfLiveChickens.vue?vue&type=script&lang=js"
import style0 from "./DashboardGenderOfLiveChickens.vue?vue&type=style&index=0&id=2b654c95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b654c95",
  null
  
)

export default component.exports